import React from 'react';

export const CheckinIntro = () => {

    return (
        <div className="px-sm-5">
            <p className={`text-center pb-0 mb-4`}>
                <small className="text-xs text-muted">
                    Find your account details on your Invoice or <span
                    className={'text-nowrap'}>reservation email.</span></small>
            </p>
        </div>
    );
};